/* Verdant Vault — theme.js v1.1 */
(function () {
  'use strict';

  var routes = window.themeRoutes || {};
  var strings = window.themeStrings || {};
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function cartType() { return document.body.getAttribute('data-cart-type'); }

  /* ───────── Scroll reveal ───────── */
  var io = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          el.classList.add('visible');
          io.unobserve(el);
          setTimeout(function () { el.style.setProperty('--i', '0'); }, 1400);
        });
      }, { threshold: 0.12 })
    : null;

  function initReveal(root) {
    $$('.reveal:not([data-reveal-init])', root).forEach(function (el) {
      el.setAttribute('data-reveal-init', '');
      if (io) io.observe(el); else el.classList.add('visible');
    });
  }

  /* ───────── Particles ───────── */
  function initParticles(root) {
    if (reduceMotion) return;
    $$('[data-particles]:not([data-init])', root).forEach(function (box) {
      box.setAttribute('data-init', '');
      for (var i = 0; i < 30; i++) {
        var p = document.createElement('div');
        p.className = 'particle';
        p.style.left = Math.random() * 100 + '%';
        p.style.top = Math.random() * 100 + '%';
        p.style.setProperty('--dur', (4 + Math.random() * 6) + 's');
        p.style.setProperty('--delay', (Math.random() * 6) + 's');
        box.appendChild(p);
      }
    });
  }

  /* ───────── 3D card tilt ───────── */
  var canTilt = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var tiltCard = null;
  document.addEventListener('mousemove', function (e) {
    if (!canTilt || reduceMotion || document.body.getAttribute('data-card-tilt') !== 'true') return;
    var card = e.target.closest ? e.target.closest('.product-card[data-tilt]') : null;
    if (tiltCard && tiltCard !== card) { tiltCard.style.transform = ''; tiltCard = null; }
    if (!card) return;
    tiltCard = card;
    var r = card.getBoundingClientRect();
    var cx = r.width / 2, cy = r.height / 2;
    card.style.transform = 'perspective(1000px) rotateX(' + (-((e.clientY - r.top - cy) / cy) * 4) + 'deg) rotateY(' + (((e.clientX - r.left - cx) / cx) * 6) + 'deg) translateY(-8px)';
  });
  document.addEventListener('mouseleave', function () {
    if (tiltCard) { tiltCard.style.transform = ''; tiltCard = null; }
  });

  /* ───────── Mobile menu ───────── */
  function closeMenu() {
    var menu = document.getElementById('MobileMenu');
    var btn = $('[data-menu-toggle]');
    if (menu && !menu.hasAttribute('hidden')) {
      menu.setAttribute('hidden', '');
      if (btn) btn.setAttribute('aria-expanded', 'false');
      return true;
    }
    return false;
  }

  /* ───────── Cart count / toast ───────── */
  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (count > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
  }

  var toastTimer;
  function showToast(message) {
    var toast = $('[data-toast]');
    if (!toast) return;
    toast.innerHTML = '';
    var span = document.createElement('span');
    span.textContent = message;
    var link = document.createElement('a');
    link.href = routes.cart || '/cart';
    link.textContent = strings.viewCart || 'View cart';
    toast.appendChild(span);
    toast.appendChild(link);
    toast.removeAttribute('hidden');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.setAttribute('hidden', ''); }, 5000);
  }

  /* ───────── Cart drawer ───────── */
  function drawer() { return $('[data-cart-drawer]'); }

  function openDrawer() {
    var d = drawer();
    if (!d) return false;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    var close = $('.drawer-close', d);
    if (close) setTimeout(function () { close.focus(); }, 50);
    return true;
  }

  function closeDrawer() {
    var d = drawer();
    if (!d || !d.classList.contains('is-open')) return false;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
    return true;
  }

  function renderDrawer(html) {
    var d = drawer();
    if (!d || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = $('[data-drawer-panel]', doc);
    var current = $('[data-drawer-panel]', d);
    if (!fresh || !current) return;
    current.innerHTML = fresh.innerHTML;
    current.setAttribute('data-item-count', fresh.getAttribute('data-item-count'));
    updateCartCount(parseInt(fresh.getAttribute('data-item-count'), 10) || 0);
  }

  function changeLine(line, quantity) {
    var panel = $('[data-drawer-panel]');
    if (panel) panel.classList.add('is-loading');
    fetch(routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: 'cart-drawer', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.sections && data.sections['cart-drawer']) renderDrawer(data.sections['cart-drawer']);
        else if (typeof data.item_count === 'number') updateCartCount(data.item_count);
      })
      .catch(function () { window.location.href = routes.cart; })
      .then(function () { if (panel) panel.classList.remove('is-loading'); });
  }

  /* ───────── Search modal + predictive search ───────── */
  var searchModal, searchInput, searchResults, searchTimer, searchAbort;

  function openSearch() {
    searchModal = $('[data-search-modal]');
    if (!searchModal) return false;
    searchInput = $('[data-search-input]', searchModal);
    searchResults = $('[data-search-results]', searchModal);
    searchModal.removeAttribute('hidden');
    document.body.classList.add('no-scroll');
    if (searchInput) setTimeout(function () { searchInput.focus(); }, 30);
    return true;
  }

  function closeSearch() {
    var m = $('[data-search-modal]');
    if (!m || m.hasAttribute('hidden')) return false;
    m.setAttribute('hidden', '');
    document.body.classList.remove('no-scroll');
    return true;
  }

  function predictiveSearch(term) {
    if (!searchResults) return;
    if (searchAbort) searchAbort.abort();
    if (term.length < 2) { searchResults.innerHTML = ''; return; }
    searchAbort = window.AbortController ? new AbortController() : null;
    var url = routes.predictive + '?q=' + encodeURIComponent(term) +
      '&section_id=predictive-search&resources[type]=product,collection,article,page&resources[limit]=6&resources[options][unavailable_products]=last';
    fetch(url, searchAbort ? { signal: searchAbort.signal } : undefined)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var res = $('[data-predictive-results]', doc);
        searchResults.innerHTML = res ? res.innerHTML : '';
      })
      .catch(function () {});
  }

  document.addEventListener('input', function (e) {
    if (!e.target.matches || !e.target.matches('[data-search-input]')) return;
    var term = e.target.value.trim();
    clearTimeout(searchTimer);
    searchTimer = setTimeout(function () { predictiveSearch(term); }, 250);
  });

  /* ───────── Global click handling ───────── */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var el;

    if ((el = t.closest('[data-menu-toggle]'))) {
      var menu = document.getElementById('MobileMenu');
      if (!menu) return;
      var open = menu.hasAttribute('hidden');
      if (open) menu.removeAttribute('hidden'); else menu.setAttribute('hidden', '');
      el.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    if ((el = t.closest('[data-cart-open]'))) {
      if (cartType() === 'drawer' && drawer()) { e.preventDefault(); closeMenu(); openDrawer(); }
      return;
    }
    if (t.closest('[data-drawer-close]')) { closeDrawer(); return; }
    if ((el = t.closest('[data-line-qty]'))) {
      e.preventDefault();
      changeLine(parseInt(el.getAttribute('data-line'), 10), Math.max(0, parseInt(el.getAttribute('data-qty'), 10)));
      return;
    }
    if (t.closest('[data-search-open]')) {
      if (openSearch()) { e.preventDefault(); closeMenu(); }
      return;
    }
    if (t.closest('[data-search-close]')) { closeSearch(); return; }
    if (t.matches && t.matches('[data-search-modal]')) { closeSearch(); return; }
    if ((el = t.closest('[data-filter-toggle]'))) {
      var f = $('[data-filters]');
      if (f) { var on = f.classList.toggle('is-open'); el.setAttribute('aria-expanded', on ? 'true' : 'false'); }
      return;
    }
    if ((el = t.closest('[data-copy-link]'))) {
      var link = el.getAttribute('data-copy-link');
      var original = el.textContent;
      if (navigator.clipboard) {
        navigator.clipboard.writeText(link).then(function () {
          el.textContent = strings.copied || 'Copied';
          setTimeout(function () { el.textContent = original; }, 2000);
        });
      }
      return;
    }
    if ((el = t.closest('.gallery-item[data-zoom]'))) {
      var box = document.createElement('div');
      box.className = 'lightbox';
      var img = document.createElement('img');
      img.src = el.getAttribute('data-zoom');
      img.alt = '';
      box.appendChild(img);
      box.addEventListener('click', function () { box.remove(); });
      document.body.appendChild(box);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var box = $('.lightbox');
    if (box) { box.remove(); return; }
    if (closeSearch()) return;
    if (closeDrawer()) return;
    closeMenu();
  });

  /* ───────── AJAX add to cart ───────── */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-ajax-add]')) return;
    if (!window.fetch || !window.FormData) return;
    var submitter = e.submitter;
    if (submitter && submitter.name === 'checkout') return;
    e.preventDefault();

    var btn = $('[data-add-btn]', form);
    if (btn && btn.disabled) return;
    var label = btn ? ($('[data-add-text]', btn) || btn) : null;
    var original = label ? label.textContent : '';
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    if (label && strings.adding) label.textContent = strings.adding;
    setFormError(form, '');

    var fd = new FormData(form);
    var useDrawer = cartType() === 'drawer' && drawer();
    if (useDrawer) {
      fd.append('sections', 'cart-drawer');
      fd.append('sections_url', window.location.pathname);
    }

    var restore = function () {
      if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
      if (label) label.textContent = original;
    };

    fetch(routes.cartAdd, { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) { setFormError(form, res.data.description || res.data.message || strings.error); return; }
        if (useDrawer && res.data.sections && res.data.sections['cart-drawer']) {
          renderDrawer(res.data.sections['cart-drawer']);
          openDrawer();
          return;
        }
        return fetch(routes.cartJs, { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) { updateCartCount(cart.item_count); showToast(strings.added || 'Added to cart'); });
      })
      .catch(function () {
        form.removeAttribute('data-ajax-add');
        HTMLFormElement.prototype.submit.call(form);
      })
      .then(restore);
  });

  function setFormError(form, message) {
    var box = $('[data-form-error]', form);
    if (box) {
      box.textContent = message || '';
      if (message) box.removeAttribute('hidden'); else box.setAttribute('hidden', '');
    } else if (message) {
      showToast(message);
    }
  }

  /* ───────── Auto-submit selects / filters / cart quantities ───────── */
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el.matches || !el.matches('[data-auto-submit]') || !el.form) return;
    var form = el.form;
    var update = form.querySelector('[name="update"]');
    if (form.requestSubmit) { update ? form.requestSubmit(update) : form.requestSubmit(); } else { form.submit(); }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    var msg = form.getAttribute && form.getAttribute('data-confirm');
    if (msg && !window.confirm(msg)) e.preventDefault();
  });

  /* ───────── Product page ───────── */
  function initProduct(root) {
    $$('[data-product-section]:not([data-init])', root).forEach(function (section) {
      section.setAttribute('data-init', '');
      var dataEl = $('[data-variants]', section);
      var variants = [];
      try { variants = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (err) { variants = []; }
      var lowThreshold = parseInt(section.getAttribute('data-low-stock'), 10) || 5;

      var idInput = $('[data-variant-id]', section);
      var priceEl = $('[data-price]', section);
      var compareEl = $('[data-compare]', section);
      var saveEl = $('[data-save]', section);
      var stockEl = $('[data-stock]', section);
      var skuWrap = $('[data-sku-wrap]', section);
      var skuEl = $('[data-sku]', section);
      var addBtn = $('[data-add-btn]', section);
      var addText = $('[data-add-text]', section);
      var qtyInput = $('[data-qty-input]', section);
      var sticky = $('[data-sticky-atc]', section);
      var stickyPrice = $('[data-sticky-price]', section);
      var stickyBtn = $('[data-sticky-add]', section);
      var stickyText = $('[data-sticky-text]', section);
      var form = $('.product-form', section);

      function setActiveMedia(id) {
        if (!id) return;
        var items = $$('.gallery-item', section);
        var found = items.some(function (item) { return item.getAttribute('data-media-id') === String(id); });
        if (!found) return;
        items.forEach(function (item) { item.classList.toggle('is-active', item.getAttribute('data-media-id') === String(id)); });
        $$('.gallery-thumb', section).forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-thumb') === String(id)); });
      }

      function setStock(v) {
        if (!stockEl) return;
        var state = 'in', text = strings.inStock;
        if (!v.available) { state = 'out'; text = strings.outOfStock; }
        else if (v.managed && v.inventory > 0 && v.inventory <= lowThreshold) {
          state = 'low'; text = (strings.lowStock || '').replace('__Q__', v.inventory);
        }
        stockEl.className = 'stock stock--' + state;
        stockEl.textContent = text || '';
      }

      function setButtons(available, label) {
        if (addBtn) addBtn.disabled = !available;
        if (addText) addText.textContent = label;
        if (stickyBtn) stickyBtn.disabled = !available;
        if (stickyText) stickyText.textContent = label;
      }

      function onOptionChange() {
        var selected = $$('[data-option]', section).map(function (fs) {
          var c = fs.querySelector('input:checked');
          return c ? c.value : null;
        });
        var match = null;
        variants.forEach(function (v) { if (v.options.every(function (o, i) { return o === selected[i]; })) match = v; });
        if (!match) { setButtons(false, strings.unavailable || 'Unavailable'); return; }

        if (idInput) idInput.value = match.id;
        if (priceEl) priceEl.textContent = match.price;
        if (stickyPrice) stickyPrice.textContent = match.price;
        if (compareEl) {
          compareEl.textContent = match.compare;
          if (match.on_sale) compareEl.removeAttribute('hidden'); else compareEl.setAttribute('hidden', '');
        }
        if (saveEl) {
          saveEl.textContent = '-' + match.save + '%';
          if (match.on_sale) saveEl.removeAttribute('hidden'); else saveEl.setAttribute('hidden', '');
        }
        if (skuEl && skuWrap) {
          skuEl.textContent = match.sku || '';
          if (match.sku) skuWrap.removeAttribute('hidden'); else skuWrap.setAttribute('hidden', '');
        }
        setStock(match);
        setButtons(match.available, match.available ? (strings.addToCart || 'Add to Cart') : (strings.soldOut || 'Sold Out'));
        setActiveMedia(match.media);
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      $$('[data-option] input', section).forEach(function (input) { input.addEventListener('change', onOptionChange); });
      $$('.gallery-thumb', section).forEach(function (t) {
        t.addEventListener('click', function () { setActiveMedia(t.getAttribute('data-thumb')); });
      });

      var minus = $('[data-qty-minus]', section), plus = $('[data-qty-plus]', section);
      if (minus && qtyInput) minus.addEventListener('click', function () { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); });
      if (plus && qtyInput) plus.addEventListener('click', function () { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; });

      // Sticky add-to-cart bar
      if (sticky && addBtn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var entry = entries[0];
          var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        }).observe(addBtn);
      }
      if (stickyBtn && form) {
        stickyBtn.addEventListener('click', function () {
          if (form.requestSubmit) form.requestSubmit(addBtn); else form.submit();
        });
      }
    });
  }

  /* ───────── Product recommendations ───────── */
  function initRecommendations(root) {
    $$('[data-recommendations]:not([data-init])', root).forEach(function (box) {
      box.setAttribute('data-init', '');
      var url = box.getAttribute('data-url');
      if (!url || box.children.length || !window.fetch) return;
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = $('[data-recommendations]', doc);
          if (fresh && fresh.children.length) { box.innerHTML = fresh.innerHTML; initReveal(box); }
        })
        .catch(function () {});
    });
  }

  /* ───────── Boot ───────── */
  function init(root) {
    root = root || document;
    initReveal(root);
    initParticles(root);
    initProduct(root);
    initRecommendations(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
